import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7363 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12C22 13.9778 21.4135 15.9112 20.3147 17.5557C19.2159 19.2002 17.6541 20.4819 15.8268 21.2388C13.9996 21.9957 11.9889 22.1937 10.0491 21.8079C8.10929 21.422 6.32746 20.4696 4.92894 19.0711C3.53041 17.6725 2.578 15.8907 2.19215 13.9509C1.8063 12.0111 2.00433 10.0004 2.76121 8.17317C3.51809 6.3459 4.79981 4.78412 6.4443 3.6853ZM12.8536 15.8536C12.9473 15.7598 13 15.6326 13 15.5V12.5C13 12.3674 12.9473 12.2402 12.8536 12.1464C12.7598 12.0527 12.6326 12 12.5 12H11.5C11.3674 12 11.2402 12.0527 11.1465 12.1464C11.0527 12.2402 11 12.3674 11 12.5V15.5C11 15.6326 11.0527 15.7598 11.1465 15.8536C11.2402 15.9473 11.3674 16 11.5 16H12.5C12.6326 16 12.7598 15.9473 12.8536 15.8536ZM12.8536 9.85355C12.9473 9.75979 13 9.63261 13 9.5V8.5C13 8.36739 12.9473 8.24021 12.8536 8.14645C12.7598 8.05268 12.6326 8 12.5 8H11.5C11.3674 8 11.2402 8.05268 11.1465 8.14645C11.0527 8.24021 11 8.36739 11 8.5V9.5C11 9.63261 11.0527 9.75979 11.1465 9.85355C11.2402 9.94732 11.3674 10 11.5 10H12.5C12.6326 10 12.7598 9.94732 12.8536 9.85355Z"
      fill="#0035A4"
    />
  </svg>
);
const SvgInfoColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgInfoColored;
